import { css } from "@emotion/css";
import { lineHeight, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
export const paragraphStyle = css({
    lineHeight: lineHeight.small,
    marginBottom: space["16"],
});
export const contentContainerStyles = css({
    "& > p": paragraphStyle,
    "> *": {
        marginBottom: space["16"],
    },
    ".helmButtonContainer": {
        marginTop: "1rem",
    },
});
// Configuration page styles
export const configurationContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: space[16],
    height: "100%",
});
export const configurationFormFieldsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: space[16],
    flex: 1,
});
export const sectionDescriptionStyles = css({
    margin: 0,
    color: themeTokens.color.text.secondary,
    font: text.body.regular.small,
});
